'use client';

import type { MutableRefObject, ReactNode } from 'react';
import { useEffect, useRef } from 'react';

const useClickAwayListener = (
  ref: MutableRefObject<HTMLDivElement> | any,
  onClickAway: () => void,
  clickAwayEnable?: boolean,
) => {
  useEffect(() => {
    const handleClickOutside = (event: any) => {
      if (ref.current && !ref.current.contains(event.target) && clickAwayEnable) onClickAway();
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [ref, clickAwayEnable]);
};

type Props = {
  onClickAway(): void;
  clickAwayEnable?: boolean;
  children?: ReactNode;
};

export const ClickAwayListener = (props: Props) => {
  const { onClickAway, clickAwayEnable, children } = props;
  const wrapperRef = useRef<HTMLDivElement>(null);
  useClickAwayListener(wrapperRef, onClickAway, clickAwayEnable);

  return <div ref={wrapperRef}>{children}</div>;
};
